<template>
    <div class="trialserial-page">
        <div class="df both-side space">
            <a-space>
                <a-cascader v-model:value="cascaderSelectValue" :options="modelOptions" @change="handleSelectModel"
                    placeholder="请选择设备型号" style="width: 240px;" allowClear>
                </a-cascader>

                <a-input v-model:value="payload.batch" @change="onSearch" placeholder="批次号" allowClear></a-input>

                <a-select style="width: 150px" placeholder="使用状态" v-model:value="payload.isUsed" allowClear
                    @change="onSearch">
                    <a-select-option :value="true">已使用</a-select-option>
                    <a-select-option :value="false">未使用</a-select-option>
                </a-select>
                <a-input style="width: 180px" @change="onSearch" v-model:value="payload.serial" placeholder="设备机身号"
                    allowClear></a-input>
            </a-space>

            <a-space>
                <a-button type="primary" @click="handleInsert">生成机身号</a-button>
                <a-button type="danger" @click="openDeleteConfirmModal"
                    :disabled="selectedRowKeys.length === 0">删除</a-button>
            </a-space>

        </div>
        <a-table :columns="columns" :dataSource="tableData" :pagination="false" rowKey="id" class="space"
            :scroll="{ y: 'calc(90vh - 240px)' }" :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)
                " :row-selection="{
                    selectedRowKeys: selectedRowKeys,
                    onChange: onSelectChange,
                }">
            <template #isUsed="{ record }">
                <a-tag v-if="record.isUsed" color="#35B7AD">已使用</a-tag>
                <a-tag v-else color="#ec975d">未使用</a-tag>
            </template>

            <template #action="{ record }">
                <a-button @click="updateStatus(record)" type="primary" size="small">修改状态</a-button>
            </template>
        </a-table>

        <a-modal v-model:visible="deleteModalVisiable" title="提示" @ok="handleDelete" @cancel="handelCancel">
            <a-input type="password" placeholder="请输入删除密码" v-model:value="deletePassword"></a-input>
        </a-modal>

        <div class="df both-side">
            <div></div>
            <a-pagination show-size-changer v-model:current="page.pageNum" v-model:pageSize="page.lineNum"
                @showSizeChange="showSizeChange" @change="currenChange" :total="page.total"
                :pageSizeOptions="['20', '50', '70', '100']" :show-total="(total) => `共 ${total} 条`" />
        </div>
    </div>

    <series-form ref="seriesFormRef" @handleUpdateTable="onSearch"></series-form>
</template>

<script>
import {
    defineComponent,
    reactive,
    ref,
    computed,
    createVNode,
    toRefs,
} from "vue";
import { Modal } from "ant-design-vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import {
    getGZSerialList,
    randomSerial,
    deleteGZSerial,
    update,
} from "@/request/view/trialProductionCenter.js";


import { notice, Toast } from "@/utils";

import { modelOptions } from '@/views/trialProductionCenter/series/data';

import cusCascader from '@/components/cascader/index.vue';
import seriesForm from '@/views/trialProductionCenter/series/form.vue';

export default defineComponent({
    components: { cusCascader, seriesForm },
    setup() {
        const tableData = reactive([]);
        const cascaderSelectValue = ref([]);
        const state = reactive({
            searchText: "",
            searchedColumn: "",
        });

        const seriesFormRef = ref("");

        const page = reactive({
            pageNum: 1,
            lineNum: 20,
            total: 0,
        });
        const formState = reactive({});

        const rules = reactive({});

        const columns = [
            {
                title: "设备类型",
                align: "center",
                dataIndex: "type",
                key: "type",
                width: 90,
            },
            {
                title: "批次号",
                align: "center",
                dataIndex: "batch",
                key: "batch",
                width: 70,
            },
            {
                title: "设备机身号",
                align: "center",
                dataIndex: "serial",
                key: "serial",
                width: 120,
            },
            {
                title: "使用状态",
                align: "center",
                dataIndex: "isUsed",
                key: "isUsed",
                slots: { customRender: "isUsed" },
                width: 100,
            },
            {
                title: "生成时间",
                align: "center",
                dataIndex: "createDate",
                key: "createDate",
                width: 140,
            },
            {
                title: "操作",
                align: "center",
                dataIndex: "action",
                key: "action",
                width: 100,
                slots: { customRender: "action" },
            },
        ];
        const payload = reactive({
            serial: null,
            isUsed: null,
            generationTimes: null,
            batch: null,
            type: null,
            batch: null,

        });
        const showSizeChange = (current, size) => {
            console.log(current, size);
            page.pageNum = current;
            page.lineNum = size;
            getData();
        };

        const getData = () => {
            selectedRowKeys.value.length = 0;
            getGZSerialList({
                batch: payload.batch,
                serial: payload.serial,
                type: payload.type,
                isUsed: payload.isUsed,
                pageNum: page.pageNum,
                lineNum: page.lineNum,
            }).then((res) => {
                tableData.length = 0;
                page.total = res.data.total;
                res.data.records.forEach((item) => {
                    if (item.type === "TE") {
                        item.type = "天鹅";
                    } else if (item.type === "TG") {
                        item.type = "天鸽";
                    }
                });
                tableData.push(...res.data.records);
            });
        };

        const onSearch = () => {
            page.pageNum = 1;
            getData();
        };

        const currenChange = (pageNumber) => {
            page.pageNum = pageNumber;
            getData();
        };

        const updateSerialStatus = (record) => {
            update({
                id: record.id,
                isUsed: !record.isUsed,
            }).then((res) => {
                let toastType = res.code === 200 ? "success" : "warning";
                Toast(toastType, res.message, 3);
                getData();
            });
        };

        const updateStatus = (record) => {
            Modal.confirm({
                title: () => "提示",
                icon: () => createVNode(ExclamationCircleOutlined),
                content: () =>
                    createVNode(
                        "div",
                        { style: "color:red;" },
                        "是否变更设备序列号使用状态？"
                    ),
                onOk() {
                    updateSerialStatus(record);
                },
                onCancel() {
                    console.log("Cancel");
                },
                class: "test",
            });
        };

        const renderSerialUpdate = (record) => {
            const targetItem = tableData.find(
                (item) => item.serial === record.serial
            );

            if (targetItem !== undefined) targetItem.isUsed = record.isUsed;
        };

        const selectedRowKeys = ref([]);
        const onSelectChange = (key) => {
            selectedRowKeys.value.length = 0;
            selectedRowKeys.value.push(...key);
        };

        const deletePassword = ref(null);
        const deleteModalVisiable = ref(false);

        const openDeleteConfirmModal = () => {
            deleteModalVisiable.value = true;
        };

        const handelCancel = () => {
            deletePassword.value = null;
            deleteModalVisiable.value = false;
        };

        const handleDelete = () => {
            if (deletePassword.value === null || deletePassword.value === "") {
                return Toast("warning", "请输入删除密码", 3);
            } else if (deletePassword.value === "qiu666") {
                deleteGZSerial(selectedRowKeys.value)
                    .then((res) => {
                        if (res.code === 200 && res.message === "成功") {
                            Toast("success", "删除成功", 3);
                        }
                        selectedRowKeys.value.length = 0;
                        getData();
                        handelCancel();
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            } else {
                Toast("warning", "密码错误", 3);
            }
        };

        getData();

        const handleInsert = () => {
            seriesFormRef.value.showModal('insert', {
                title: "生成机身号"
            });
        };

        const handleSelectModel = (e, options) => {
            const [series, model] = options;
            if (model) {
                payload.type = model.value;
            } else {
                payload.type = null;
            }
            onSearch()
        };

        return {
            payload,
            columns,
            tableData,
            ...toRefs(state),
            handleSelectModel,
            currenChange,
            handleInsert,
            page,
            seriesFormRef,
            formState,
            rules,
            cascaderSelectValue,
            onSearch,
            showSizeChange,
            updateStatus,
            renderSerialUpdate,
            handleDelete,
            selectedRowKeys,
            onSelectChange,
            openDeleteConfirmModal,
            deletePassword,
            deleteModalVisiable,
            handelCancel,
            modelOptions,
        };
    },
});
</script>

<style lang="less">
.trialserial-page {
    height: calc(100vh - 120px);
    width: 100%;
    background: #fff;
    border-radius: 10px;
    padding: 20px;
    box-shadow: 0 0 10px 0 #ccc;

    .space {
        margin-bottom: 10px;
    }
}
</style>